import { createWebHistory, createRouter, RouteRecordRaw } from "vue-router";

import Img from "../views/upload/Img.vue";
import Text from "../views/upload/Text.vue";
import Video from "../views/upload/Video.vue";
import DataStatistics from "../views/dataStatistics/Index.vue";
import Login from "../views/login/Index.vue";
import Register from "../views/register/Index.vue";
import Home from "../views/Index.vue";
import OverviewData from "../views/overview/Data.vue";
import OverviewDataStatistics from "../views/overview/DataStatistics.vue";
import OverviewAuditLog from "../views/overview/AuditLog.vue";
import UserManagement from "../views/management/userManagement.vue";
import EquipmentManagement from "../views/management/EquipmentManagement.vue";
import PolicyManagement from "../views/management/policyManagement.vue";
import PersonalInfoManagement from "../views/management/personalInfoManagement.vue";
import SecurityMap from "../views/map/SecurityMap.vue";
import Maintenance from "../views/Maintenance.vue";
import { getUserInfo } from "../utils/index";
import store from "../store";
// import { getMaintenanceStatus } from "../api/index";

const routes = [
  {
    path: "/login",
    name: "login",
    components: { login: Login },
    meta: { requiresAuth: false },
  },
  {
    path: "/register",
    name: "register",
    components: { register: Register },
    meta: { requiresAuth: false },
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: Maintenance,
    meta: { requiresAuth: false },
  },
  {
    path: "/",
    name: "home",
    component: Home,
    children: [
      {
        path: "overview-dataStatistics",
        name: "overview-dataStatistics",
        component: OverviewDataStatistics,
        meta: { requiresAuth: true }, // 受保护的路由
      },
      {
        path: "overview-auditLog",
        name: "overview-auditLog",
        component: OverviewAuditLog,
        meta: { requiresAuth: true }, // 受保护的路由
      },
      {
        path: "upload-img",
        name: "uploadImg",
        component: Img,
        meta: { requiresAuth: true }, // 受保护的路由
      },
      {
        path: "upload-text",
        name: "uploadText",
        component: Text,
        meta: { requiresAuth: true }, // 受保护的路由
      },
      {
        path: "upload-video",
        name: "uploadVideo",
        component: Video,
        meta: { requiresAuth: true }, // 受保护的路由
      },
      {
        path: "data-statistics",
        name: "dataStatistics",
        component: DataStatistics,
        meta: { requiresAuth: true }, // 受保护的路由
      },
      {
        path: "userManagement",
        name: "userManagement",
        component: UserManagement,
        meta: { requiresAuth: true }, // 受保护的路由
      },
      {
        path: "equipmentManagement",
        name: "equipmentManagement",
        component: EquipmentManagement,
        meta: { requiresAuth: true }, // 受保护的路由
      },
      {
        path: "policyManagement",
        name: "policyManagement",
        component: PolicyManagement,
        meta: { requiresAuth: true }, // 受保护的路由
      },
      {
        path: "personalInfoManagement",
        name: "personalInfoManagement",
        component: PersonalInfoManagement,
        meta: { requiresAuth: true }, // 受保护的路由
      },
      // {
      //   path: "security-map",
      //   name: "SecurityMap",
      //   component: () => import("../views/map/SecurityMap.vue"),
      //   meta: { requiresAuth: true },
      // },
      {
        path: "", // 空字符串表示父路由的根路径
        redirect: "overview-dataStatistics", // 重定向到 'overview' 子路由
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: routes as RouteRecordRaw[],
});

// 路由守卫
router.beforeEach(async (to, _from, next) => {
  // 登录页、注册页、维护页面直接放行
  if (
    to.path === "/login" ||
    to.path === "/register" ||
    to.path === "/maintenance"
  ) {
    next();
    return;
  }

  // 路由跳转前检测维护状态
  // try {
  //   const res = await getMaintenanceStatus();
  //   if (res?.code === "success" && res.content) {
  //     const maintenanceInfo = res.content as {
  //       isMaintenance?: boolean;
  //       message?: string;
  //       startTime?: string;
  //       endTime?: string;
  //     };
  //     // 更新 store 中的维护信息
  //     store.dispatch("maintenance/setMaintenanceInfo", maintenanceInfo);
  //   }
  // } catch (error) {
  //   // 接口失败时，使用 store 中的现有状态作为兜底
  //   console.warn("获取维护状态失败，使用缓存状态:", error);
  // }

  // 从 store 中获取维护状态
  const isMaintenance = store.getters["maintenance/isMaintenance"];

  // 如果系统正在维护，检查用户是否有权限绕过维护限制
  if (isMaintenance) {
    // 获取用户信息（登录时存储的 role 是准确的，因为来自登录接口）
    const userInfo = getUserInfo();
    const userRole = userInfo?.role;

    // 超级管理员在维护期间正常访问系统
    // 其他用户会被拦截到维护页面
    if (userRole === "superadmin") {
      // 超级管理员可以正常访问，继续后续的权限检查
      // 不 return，继续执行下面的逻辑
    } else {
      // 普通用户或未登录用户，跳转到维护页面
      next({
        path: "/maintenance",
      });
      return;
    }
  }

  // 获取token（用于登录权限检查）
  const token = getUserInfo()?.token;

  // 需要登录权限的页面
  if (to.matched.some((record) => record.meta.requiresAuth && !token)) {
    // 没有token,跳转到登录页
    next({
      path: "/login",
      query: { redirect: to.fullPath },
    });
  } else {
    // 不需要登录权限的页面直接放行
    next();
  }
});

export default router;
